import Link from "next/link";
import * as React from "react";
import Image from "next/image";
import { Article } from "@/types/index";
import styles from "./styles.module.css";

const ArticleCard: React.FC<{ article: Article }> = ({ article }) => {
	return (
		<div className={styles.card}>
			<div className={styles.card__image__container}>
				{article.fields.banner && (
					<Image
						layout="fill"
						objectFit="cover"
						alt={article.fields.banner.fields.description ?? ""}
						src={`https:${article.fields.banner.fields.file?.url}`}
					/>
				)}
			</div>
			<div className={styles.card__body}>
				<h3>
					<Link href={`/broadband/guides/${article.fields.slug}`}>
						{article.fields.title}
					</Link>
				</h3>
				<p>{article.fields.description}</p>
			</div>
		</div>
	);
};

export default ArticleCard;
